import React from "react";
import theme from "../../../theme";
import IconStyles from "../Icon.styles";
import { IStreetlightIconProps } from "../Icon.types";

const DECORATIVE_ICON: React.FC<IStreetlightIconProps> = (
  props: IStreetlightIconProps
) => {
  const { reported, className, type } = props;
  let { bgFill, fill } = props;

  if (!bgFill) {
    bgFill = reported
      ? theme.CE_THEME.colors.alerts.secondary
      : theme.CE_THEME.colors.brand.primary;
  }

  if (!fill) {
    fill = "#ffffff";
  }

  return (
    <IconStyles.StreetlightIcon
      id={`${type}`}
      className={`${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 360 360"
    >
      <circle fill={bgFill} cx="180" cy="180" r="180" />
      <g>
        <line
          strokeWidth="12.21"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          x1="180"
          y1="149.927"
          x2="180"
          y2="317.23"
        />
        <path
          fill={fill}
          d="M185.99,41.99a5.99,5.99,0,1,0-8.788,5.294h-.2V50.8H183V47.284h-.2A5.988,5.988,0,0,0,185.99,41.99Z"
        />
        <path
          fill={fill}
          d="M140.35,53.3,129.975,76.447a2.114,2.114,0,0,0,1.929,2.979H228.1a2.114,2.114,0,0,0,1.929-2.979L219.65,53.3a4.24,4.24,0,0,0-3.868-2.505H144.218A4.24,4.24,0,0,0,140.35,53.3Z"
        />
        <g>
          <polyline
            fill="none"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="6.655"
            className="decorative-4"
            points="140.748 79.194 152.519 132.899 180 132.899 207.481 132.899 219.252 79.194"
          />
          <line
            fill="none"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="6.655"
            className="decorative-4"
            x1="162.55"
            y1="79.602"
            x2="171.876"
            y2="132.491"
          />
          <line
            fill="none"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="6.655"
            className="decorative-4"
            x1="197.45"
            y1="78.261"
            x2="188.124"
            y2="131.149"
          />
        </g>
      </g>
    </IconStyles.StreetlightIcon>
  );
};

export default DECORATIVE_ICON;
